import React, { useRef, useEffect } from 'react'
import ReactDOM from 'react-dom'
import message from 'antd/lib/message'

import './PvSnackbarRootComponent.scss'

const PvSnackbarRootComponent = () => {
  const rootRef = useRef()

  const setMessageConfig = () => {
    message.config({
      getContainer: () => rootRef.current,
      maxCount: 1,
      top: window.innerHeight - 64, // 48px is bar height + 16px margin bottom
    })
  }

  useEffect(() => {
    setMessageConfig()
    window.addEventListener('resize', setMessageConfig)

    return () => {
      window.removeEventListener('resize', setMessageConfig)
    }
  }, [])

  return ReactDOM.createPortal(
    <div ref={rootRef} className="pv-snackbar-root-component antd-component" />,
    document.body
  )
}

export default React.memo(PvSnackbarRootComponent)
export { PvSnackbarRootComponent }
